<template>
    <div class="cr:h-full cr:z-50 cr:bg-opacity-0 cr:transparent cr:inset-0 cr:flex cr:items-center cr:backdrop-blur-sm cr:justify-center"
        :class="[inline ? 'cr:block' : fullscreen ? 'cr:fixed' : 'cr:absolute']"
    >
        <div>
            <div class="cr-loading-spinner cr:rounded-full cr:mx-auto cr:relative"
                :class="[tiny ? 'cr:w-8 cr:h-8 cr:border-r-2'
                : small ? 'cr:w-24 cr:h-24 cr:border-r-2'
                : 'cr:w-32 cr:h-32 cr:border-r-4', originClasses]"
            />
        </div>
    </div>
</template>

<script setup lang="ts">

import {useRegistrationStore} from "@/stores/registration.ts";
import {computed} from "vue";
import {ORIGINS} from "@/services/ConstantSerice.ts";

const registrationStore = useRegistrationStore();
const props = defineProps({
    small: {
        type: Boolean,
        default: false
    },
    fullscreen: {
        type: Boolean,
        default: false,
    },
    inline: {
        type: Boolean,
        default: false,
    },
    tiny: {
        type: Boolean,
        default: false,
    }
});

const originClasses = computed(() => {
    switch (registrationStore.registrationOrigin?.toLocaleLowerCase()) {
        case ORIGINS.BE:
            return 'cr:border-[var(--be-primary)]';
        case ORIGINS.KE:
            return 'cr:border-[var(--ke-primary)]';
        case ORIGINS.FIXR:
            return 'cr:border-[var(--fixr-primary)]';
        case ORIGINS.SR:
            return 'cr:border-[var(--sr-primary)]';
        case ORIGINS.RC:
            return 'cr:border-[var(--rc-primary)]';
        default:
            return 'cr:border-[var(--default-primary)]';
    }
});

</script>

<style scoped>
.cr-loading-spinner {
    animation: spin 1.3s linear infinite;
}

@keyframes spin {
    0%   { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
</style>